import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Sparkles, X, Coins, Flame } from "lucide-react";

export default function WelcomeCardModal() {
  const { user, setUser } = useAuth();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.welcome_card_seen || user.role === "admin") return;
    // mid-registration from the public sign-up funnel: don't cover the Register card — show it next visit
    if (window.location.search.includes("register=") || window.location.search.includes("from=toursignup")) return;
    setShow(true);
    setUser((u) => (u ? { ...u, welcome_card_seen: true } : u));
    api.post("/profile/welcome-card-seen").catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  if (!show) return null;
  const close = () => setShow(false);

  return (
    <div className="fixed inset-0 z-[96] bg-black/90 flex items-center justify-center p-4" data-testid="welcome-card-modal">
      <div className="relative bg-pb-surface border-2 border-pb-red max-w-md w-full p-6 text-center overflow-hidden">
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-pb-red/20 rounded-full blur-2xl pointer-events-none" />
        <button data-testid="welcome-card-close" onClick={close}
          className="absolute top-3 right-3 text-zinc-500 hover:text-white"><X className="w-4 h-4" /></button>
        <Sparkles className="w-8 h-8 text-pb-red mx-auto mb-2" />
        <div className="font-display font-black uppercase text-2xl leading-tight mb-1">
          Welcome to the Bullpen{user?.name ? `, ${user.name.split(" ")[0]}` : ""}!
        </div>
        <div className="text-pb-red font-black uppercase tracking-[0.2em] text-xs mb-4">
          Mint your Game Player Card now
        </div>
        <div className="bg-yellow-400/10 border border-yellow-400/60 px-3 py-2 mb-4" data-testid="welcome-card-offer">
          <span className="text-[11px] font-black uppercase tracking-widest text-yellow-300">
            🎁 Welcome gift: your Game Player Card mints FREE — next 24 hours only
          </span>
          <div className="text-[9px] uppercase tracking-widest text-fuchsia-300 mt-1">
            + unlock Prism, Galaxy &amp; Comic Hero borders — the same exclusive styles the Bullpen forges with
          </div>
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed mb-3">
          One photo becomes your <span className="font-bold text-white">battle-ready</span> AI trading card — your face,
          your stats, and your CARD WARS powers stamped in gold: <span className="font-bold text-yellow-300">DINK · POWER
          · SPEED · IQ · CLUTCH</span>. It's the card you'll fight with in Court Clash.
        </p>
        <div className="text-left space-y-2 mb-5">
          <div className="flex items-start gap-2 text-xs text-zinc-400">
            <Coins className="w-3.5 h-3.5 text-yellow-400 shrink-0 mt-0.5" />
            <span><span className="text-white font-bold">You get paid.</span> Every time another player rips a pack and pulls YOUR card, a royalty lands in your wallet. Automatically. Forever.</span>
          </div>
          <div className="flex items-start gap-2 text-xs text-zinc-400">
            <Flame className="w-3.5 h-3.5 text-pb-red shrink-0 mt-0.5" />
            <span><span className="text-white font-bold">Level up, re-mint.</span> As your level climbs, mint fresh Game Cards with stronger battle stats — early RC-badged cards become the ones collectors chase.</span>
          </div>
        </div>
        <button data-testid="welcome-card-cta" onClick={() => { close(); navigate("/profile"); }}
          className="w-full bg-pb-red text-black font-black uppercase tracking-widest py-3 text-sm hover:brightness-110 transition-all mb-2">
          Make My Game Card
        </button>
        <button data-testid="welcome-card-later" onClick={close}
          className="text-[10px] uppercase tracking-widest text-zinc-500 hover:text-zinc-300">
          Maybe later
        </button>
      </div>
    </div>
  );
}
